import {h, Fragment} from "preact"
import { useSizeOptions } from '@nosto/preact'
import { defaultConfig, sizes } from '../config'
import Pagination from './Pagination'

export default function BottomToolbar() {
    const { from, to, size, total, handleSizeChange, sizeOptions } = useSizeOptions(
        sizes,
        defaultConfig.serpSize
    )

    if (total <= size) {
        return null
    }

    return (
        <nav class="pagination heading-color" role="navigation" aria-label="Pagination navigation">
            <Pagination />
        </nav>
    )
}